/**
 * The notification feed behind the bell (decision D30).
 *
 * The durable half of telling someone something. `push/push-payload.ts` is the
 * transient half — same `PushCategory`, deliberately, so the two can never disagree
 * about what kind of thing happened.
 */
import { z } from 'zod';
import { pushCategorySchema } from '../push/push-payload.js';
export const notificationSchema = z.object({
    id: z.string(),
    category: pushCategorySchema,
    title: z.string(),
    body: z.string(),
    /** Where tapping it goes. Null for something with nowhere to send you. */
    url: z.string().nullable(),
    /** Null until opened. */
    readAt: z.string().nullable(),
    createdAt: z.string(),
});
//# sourceMappingURL=notifications.js.map